import type { TranslationFunction } from "@/language/translation";
import { actionIdPrefix, eventIdPrefix } from "@/components/event-action/event/EventActionIdPrefix";
import { type GSSearchGloballyQuery, GSSearchResultType } from "@/graphql";

export function getSearchResultName(
  searchResult: GSSearchGloballyQuery["GSSearchGlobally"][0],
  t: TranslationFunction,
) {
  /* eslint-disable no-case-declarations */
  switch (searchResult.type) {
    case GSSearchResultType.EVENT:
      const eventMeta = searchResult.meta;
      if (eventMeta.__typename !== "GSSearchResultEventMeta") {
        return "";
      }
      return t("modules.commandMenu.views.CommandMenu.event", {
        eventId: `${eventIdPrefix[eventMeta.eventType]}${eventMeta.eventId}`,
        description: searchResult.meta.boardName,
      });
    case GSSearchResultType.ACTION:
      const actionMeta = searchResult.meta;
      if (actionMeta.__typename !== "GSSearchResultActionMeta") {
        return "";
      }
      return t("modules.commandMenu.views.CommandMenu.action", {
        eventId: `${eventIdPrefix[actionMeta.eventType]}${actionMeta.eventId}`,
        actionId: `${actionIdPrefix[actionMeta.actionType]}${actionMeta.actionId}`,
        description: searchResult.meta.boardName,
      });
    case GSSearchResultType.TILE:
      const tileMeta = searchResult.meta;
      if (tileMeta.__typename !== "GSSearchResultTileMeta") {
        return "";
      }
      return t("modules.commandMenu.views.CommandMenu.tile", {
        tileName: t(`dynamic.${tileMeta.tileNameId}`),
        tileId: tileMeta.tileId,
        boardName: tileMeta.boardName ?? t("global.na"),
        boardId: tileMeta.boardId,
      });

    case GSSearchResultType.BOARD:
      const boardMeta = searchResult.meta;
      if (boardMeta.__typename !== "GSSearchResultBoardMeta") {
        return "";
      }
      return t("modules.commandMenu.views.CommandMenu.board", {
        boardName: boardMeta.boardName ?? t("global.na"),
        boardId: boardMeta.boardId,
      });
    default:
      return "";
    /* eslint-enable no-case-declarations */
  }
}
